/**
 * SPDX-FileCopyrightText: 2024 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */

import { loadState } from '@nextcloud/initial-state'

const appStoreEnabled = loadState('photos', 'appStoreEnabled', false) as boolean
export default appStoreEnabled
